import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService } from 'src/app/services/auth.service';
import { mergeMap } from 'rxjs/operators';

@Injectable()
export class HttpTokenInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    if (!this.authService) {
      return next.handle(request);
    }
    return this.authService.addTokenToHeader(request.headers).pipe(
      mergeMap((headersWithBearer: any) => {
        const kcReq = request.clone({ headers: headersWithBearer });
        return next.handle(kcReq);
      })
    );
  }
}
